<template>
  <li class="trending-topic-item">
    <router-link 
      :to="{ name: 'ForumThread', params: { nid: topic.id } }" 
      class="topic-link typo-body-2"
    >
      {{ topic.title }}
      <span class="replies-count">({{ topic.repliesCount }})</span>
    </router-link>
  </li>
</template>

<script>
export default {
  name: 'TrendingTopic',
  props: {
    topic: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.trending-topic-item {
  margin-bottom: 10px;
  list-style-type: none;
}

.topic-link {
  color: var(--color-text-primary);
  text-decoration: none;
  display: block;
  padding: 8px 0;
  transition: color 0.3s ease;
}

.topic-link:hover {
  color: var(--color-highlight);
}

.replies-count {
  color: var(--color-text-secondary);
  font-size: 0.9em;
}
</style> 